/**
 * 地区三级联动控件
 * 
 * Created by XuDL(Wisea) on 2016/08/26
 */
;
(function(window, $, undefined) {
	var dataStroe = $(this).DataStore();
	var subAreaTree = dataStroe.getType("SubAreas");

	"use strict";

	/** 构造函数 */
	var AreaLinkage = function(element, options) {
		var $that = this;
		this.options = options;
		// 设置控件
		this.area1 = $(this.options.selectors[0]);
		this.area2 = $(this.options.selectors[1]);
		this.area3 = $(this.options.selectors[2]);
		this.actors = [this.area1, this.area2, this.area3];

		// 初始显示省数据
		var province = this.getSubAreas();
		this.getOptions(province, this.area1.selector);

		// 注册联动事件
		if (this.area1.length > 0) {
			this.area1.on('change', function() {
				$that.linkage('1', $that.area1.selector, $that.area2.selector, $that.area3.selector);
			});
		}
		if (this.area2.length > 0) {
			this.area2.on('change', function() {
				$that.linkage('2', $that.area1.selector, $that.area2.selector, $that.area3.selector);
			});
		}

		// 默认选中
		if (this.options.values && this.options.values.length > 0) {
			if (this.options.values[0]) {
				$that.setSelected($that.area1.selector, this.options.values[0]);
			}
			if (this.options.values[1]) {
				$that.setSelected($that.area2.selector, this.options.values[1]);
			}
			if (this.options.values[2]) {
				$that.setSelected($that.area3.selector, this.options.values[2]);
			}
		}
	};

	AreaLinkage.prototype = {
		constructor: AreaLinkage,
		getSubAreas: function(code, list) {
			if (code) {
				var res = null;
				if (list) {
					$.each(list, function(i, n) {
						if (code == n.code) {
							res = n.children;
							return false;
						}
						if (n.children) {
							res = AreaLinkage.prototype.getSubAreas(code, n.children);
						}
						if (res) {
							return false;
						}
					});
				} else {
					$.each(subAreaTree[0].children, function(i, n) {
						if (code == n.code) {
							res = n.children;
							return false;
						}
						if (n.children) {
							res = AreaLinkage.prototype.getSubAreas(code, n.children);
						}
						if (res) {
							return false;
						}
					});
				}
				return res;
			} else {
				return subAreaTree[0].children;
			}
		},
		getOptions: function(recordList, selector) {
			var res = [$("<option/>").attr("value", "").text("请选择")];
			if (recordList) {
				$.each(recordList, function(i, n) {
					res.push($("<option/>").attr("value", n.code).text(n.name));
				});
			}
			if (selector) {
				$(selector).children().remove();
				$(selector).append(res);
			}
			// 默认请选择
			$(selector).select2("val", "");
			return res;
		},
		linkage: function(data) {
			var area1 = arguments[1] || "#areaCode1";
			var area2 = arguments[2] || "#areaCode2";
			var area3 = arguments[3] || "#areaCode3";
			var areaCode = $(area1).select2("val");
			if (data == '2') {
				areaCode = $(area2).select2("val");
			}
			if (!areaCode) {
				if (data == '1') {
					$(area2).html("");
					$(area2).select2("val", "");
					$(area3).html("");
					$(area3).select2("val", "");

				} else if (data == '2') {
					$(area3).html("");
					$(area3).select2("val", "");
				}
				return;
			}
			var recordList = this.getSubAreas(areaCode);
			var html = this.getOptions(recordList);

			if (data == '1') {
				$(area2).html(html);
				$(area2).select2("val", "");
				$(area3).html("");
				$(area3).select2("val", "");

			} else if (data == '2') {
				$(area3).html(html);
				$(area3).select2("val", "");
			}
		},
		setSelected: function(selector, val) {
			$(selector).select2("val", val);
			$(selector).trigger('change');
		},
		getSelected: function(domSelector) {
			if ($(domSelector).length > 0) {
				var select = $(domSelector).select2("data");
				if (select) {
					return {
						"text": $(domSelector).select2("data").text,
						"value": $(domSelector).select2("val")
					};
				}
				return null;
			}
			return null;
		},
		getValues: function() {
			var areaLinkage = this.data("AreaLinkage");
			if (areaLinkage) {
				var res = [];
				$.each(areaLinkage.actors, function(i, n) {
					if ($(n).length > 0) {
						var sec = areaLinkage.getSelected(n);
						if (sec) {
							res.push(sec);
						}
					}
				});
				return res;
			}
			return null;
		}
	};

	/**
	 * 数据字典JQuery拓展
	 * 
	 * showLog:false,// 是否显示操作日志(默认:false) data : {} // 数据字典(默认:{})
	 * 
	 */
	$.fn.AreaLinkage = function(option) {
		// 得到入参
		var args = arguments;
		// 注册子方法
		this.setSelected = AreaLinkage.prototype.setSelected;
		this.getSelected = AreaLinkage.prototype.getSelected;
		this.getValues = AreaLinkage.prototype.getValues;

		// 保持链式
		return this.each(function() {
			// 初始化
			var $this = $(this),
				myTool = $this.data("AreaLinkage"),
				options = $
				.extend({}, $.fn.AreaLinkage.defaults,
					typeof option == "object" && option);
			if (!myTool) {
				$this.data("AreaLinkage", (myTool = new AreaLinkage(this, options)));
			}
			// 判断类型
			if (typeof option == "string") {
				// 调用函数
				if (myTool[option]) {
					// return myTool[option](Array.prototype.slice.call(args,
					// 1));//等价下一句的效果
					return myTool[option].apply(myTool, Array.prototype.slice
						.call(args, 1));
				} else {
					$.error("Method " + method + " does not exist on jQuery.AreaLinkage");
				}
			}
		});
	};

	$.fn.AreaLinkage.defaults = {
		"selectors": ["#areaCode1", "#areaCode2", "#areaCode3"],
		"values": []
	};
})(window, window.jQuery);


//////////////////
// WEBPACK FOOTER
// ./static/js/AreaLinkage.js
// module id = 9hD8
// module chunks = 11